import { useQuery } from "@tanstack/react-query";
import {
  fetchDailyAnalytics,
  fetchAnalyticsSummary,
} from "@/service/analyticsService";
import { DailyAnalytics } from "@/model/entities";

/**
 * Hook to fetch daily analytics for a restaurant
 */
export function useDailyAnalytics(
  restaurantId: string,
  startDate: Date,
  endDate: Date,
  enabled: boolean = true
) {
  return useQuery<DailyAnalytics[], Error>({
    queryKey: ["dailyAnalytics", restaurantId, startDate, endDate],
    queryFn: () => fetchDailyAnalytics(restaurantId, startDate, endDate),
    enabled: enabled && !!restaurantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

/**
 * Hook to fetch analytics summary for a restaurant
 */
export function useAnalyticsSummary(
  restaurantId: string,
  startDate: Date,
  endDate: Date,
  enabled: boolean = true
) {
  return useQuery<{ totalViews: number; totalUniqueVisitors: number }, Error>({
    queryKey: ["analyticsSummary", restaurantId, startDate, endDate],
    queryFn: () => fetchAnalyticsSummary(restaurantId, startDate, endDate),
    enabled: enabled && !!restaurantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
